<app-header></app-header>
<app-offer-banner></app-offer-banner>
<app-home *ngIf='router.url=="/"'></app-home>
<router-outlet></router-outlet>
<app-footer></app-footer>